import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import mixpanel from '../../../../../../src/web/utils/mixpanel';
import SelectedUnitModal from '../../SelectedUnitModal';
import ActionArrow from './ActionArrow';
import ActionButtons from './ActionButtons';
import ActionButtonsTierPricing from './ActionButtonsTierPricing';
import styles from './Actions.scss';

const propTypes = {
  actionContainerClassName: PropTypes.string,
  moveInUrl: PropTypes.string,
  renderArrow: PropTypes.bool,
  reservationUrl: PropTypes.string,
  enableTieredPricing: PropTypes.bool,
  toggleTiers: PropTypes.func.isRequired,
  isUnitGroupExpanded: PropTypes.bool,
};

const defaultProps = {
  actionContainerClassName: 'd-none d-md-block',
  moveInUrl: undefined,
  renderArrow: undefined,
  reservationUrl: undefined,
  enableTieredPricing: false,
  isUnitGroupExpanded: false,
};

const addWebsiteQueryParam = (url) => {
  if (!url) {
    return '';
  }

  return url.replace(/\?/, '?fromWebsite=true&');
};

const addMixpanelQueryParam = (url, mixpanelDistinctId) => {
  if (!url) {
    return '';
  }

  return url.replace(/companyId=/, `mpid=${mixpanelDistinctId}&companyId=`);
};

const Actions = ({
  actionContainerClassName,
  moveInUrl,
  renderArrow,
  reservationUrl,
  enableTieredPricing,
  toggleTiers,
  isUnitGroupExpanded,
  ...rest
}) => {
  const [fullMoveInUrl, setFullMoveInUrl] = useState(addWebsiteQueryParam(moveInUrl));
  const [fullReserveUrl, setFullReserveUrl] = useState(addWebsiteQueryParam(reservationUrl));
  const [showSelectedUnitModal, setShowSelectedUnitModal] = useState(false);
  const [showRentalShortFormModal, setShowRentalShortFormModal] = useState(false);

  const closeSelectedUnitModal = () => setShowSelectedUnitModal(false);

  const toggleSelectedUnitModal = () => setShowSelectedUnitModal(!showSelectedUnitModal);

  const toggleRentalShortFormModal = () => setShowRentalShortFormModal(!showRentalShortFormModal);

  // We can only get the mixpanel distinct ID on the client side.
  useEffect(() => {
    const mixpanelDistinctId = mixpanel.getDistinctId();

    if (mixpanelDistinctId) {
      setFullMoveInUrl(addMixpanelQueryParam(fullMoveInUrl, mixpanelDistinctId));
      setFullReserveUrl(addMixpanelQueryParam(fullReserveUrl, mixpanelDistinctId));
    }
  }, []);

  const actionButtonsProps = {
    ...rest,
    moveInUrl: fullMoveInUrl,
    reservationUrl: fullReserveUrl,
    showRentalShortFormModal,
    toggleRentalShortFormModal,
  };

  return (
    <div className={styles.root}>
      {renderArrow && (
        <ActionArrow
          toggleModal={toggleSelectedUnitModal}
          enableTieredPricing={enableTieredPricing}
          toggleTiers={toggleTiers}
          isUnitGroupExpanded={isUnitGroupExpanded}
        />
      )}
      {showSelectedUnitModal ? (
        <SelectedUnitModal {...rest} handleClose={closeSelectedUnitModal}>
          {
            enableTieredPricing
              ? (
                <ActionButtonsTierPricing
                  {...actionButtonsProps}
                  inModalContext
                  toggleTiers={toggleTiers}
                  closeSelectedUnitModal={closeSelectedUnitModal}
                />
              )
              : (
                <ActionButtons
                  {...actionButtonsProps}
                  inModalContext
                  closeSelectedUnitModal={closeSelectedUnitModal}
                />
              )
          }
        </SelectedUnitModal>
      ) : (
        <div className={actionContainerClassName}>
          {
            enableTieredPricing
              ? (
                <ActionButtonsTierPricing
                  {...actionButtonsProps}
                  inModalContext={false}
                  toggleTiers={toggleTiers}
                  isUnitGroupExpanded={isUnitGroupExpanded}
                />
              )
              : (
                <ActionButtons
                  {...actionButtonsProps}
                  inModalContext={false}
                />
              )
          }
        </div>
      )}
    </div>
  );
};

Actions.propTypes = propTypes;
Actions.defaultProps = defaultProps;

export default Actions;
